var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveStarred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_43_3",
    "data-name": "Component 43 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "activeStarred"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29238",
    "data-name": "Rectangle 29238",
    width: 16,
    height: 16,
    transform: "translate(653 508)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_656",
    "data-name": "Mask Group 656",
    transform: "translate(-653 -508)",
    clipPath: "url(#activeStarred)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill",
    d: "M10.9,13.383a.683.683,0,0,1-.318-.079L7,11.419,3.414,13.3a.684.684,0,0,1-.991-.721L3.107,8.59.206,5.763A.684.684,0,0,1,.586,4.6l4.008-.583L6.387.381a.684.684,0,0,1,1.227,0L9.407,4.014l4.008.583a.684.684,0,0,1,.379,1.166l-2.9,2.827.684,3.993a.684.684,0,0,1-.673.8Z",
    transform: "translate(654 509.309)",
    fill: "#7e59d1",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStarred);
export default __webpack_public_path__ + "static/media/activeStarred.96b1e9a8cd2a0d9c04ab1a4fed5fd521.svg";
export { ForwardRef as ReactComponent };